"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[575],{

/***/ 3575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/PhoneIcon.js
var PhoneIcon = __webpack_require__(1014);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/EnvelopeIcon.js
var EnvelopeIcon = __webpack_require__(1597);
// EXTERNAL MODULE: ./src/components/Fields.jsx
var Fields = __webpack_require__(8391);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(1109);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(196);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/ContactForm.jsx






function ContactForm() {
    const [success, setSuccess] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)(null);
    const { register , handleSubmit , watch , formState: { errors  }  } = (0,index_esm/* useForm */.cI)();
    const onSubmit = (data)=>{
        axios/* default.post */.ZP.post("/api/contact-form", data).then(function(response) {
            setError(null);
            setSuccess(true);
        }).catch(function(error) {
            var ref, ref1;
            if (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                setError(error.response.data.message);
            } else {
                setError("Er ging iets mis bij het versturen van het formulier. Probeer het later opnieuw.");
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight font-display",
                children: "Stuur een bericht"
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-md bg-red-50 p-4 mt-4 -mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: "1.5",
                                stroke: "currentColor",
                                className: "h-5 w-5 text-red-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-sm font-medium text-red-800",
                                children: error
                            })
                        })
                    ]
                })
            }),
            success ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-md bg-green-50 p-4 mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: "1.5",
                                stroke: "currentColor",
                                className: "h-5 w-5 text-green-400",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-sm font-medium text-green-800",
                                    children: "Bericht verstuurd"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-2 text-sm text-green-700",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Bedankt voor je bericht. We komen hier zo snel mogelijk op terug."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "mt-10 grid grid-cols-1 gap-y-8 gap-x-6 sm:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields/* TextField */.nv, {
                        label: "Voornaam",
                        id: "first_name",
                        name: "first_name",
                        type: "text",
                        autoComplete: "given-name",
                        required: true,
                        register: register("first_name", {
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields/* TextField */.nv, {
                        label: "Achternaam",
                        id: "last_name",
                        name: "last_name",
                        type: "text",
                        autoComplete: "family-name",
                        required: true,
                        register: register("last_name", {
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields/* TextField */.nv, {
                        className: "col-span-full",
                        label: "Email",
                        id: "email",
                        name: "email",
                        type: "email",
                        autoComplete: "email",
                        required: true,
                        register: register("email", {
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fields/* TextArea */.Kx, {
                        className: "col-span-full",
                        label: "Bericht",
                        id: "message",
                        name: "message",
                        required: true,
                        register: register("message", {
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            variant: "solid",
                            color: "blue",
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Versturen ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "→"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/ContactInfo.jsx





function ContactInfo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-7xl py-16 px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-lg md:grid md:max-w-none md:grid-cols-2 md:gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight font-display",
                                        children: "Adviseurs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-lg text-gray-500",
                                            children: "Heb je nog geen contact gehad met onze adviseurs of ben je op zoek naar meer informatie?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-9",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon, {
                                                            className: "h-6 w-6 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ml-3 text-base text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:073 203 2572",
                                                                className: "text-gray-500 hover:text-gray-600",
                                                                children: "073 203 2572"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "mt-1",
                                                                children: "Ma-Vr van 09:00 tot 17:00"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6 flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvelopeIcon, {
                                                            className: "h-6 w-6 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-3 text-base text-gray-500",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:support@bijlesplein.nl",
                                                            className: "text-gray-500 hover:text-gray-600",
                                                            children: "advies@bijlesplein.nl"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-12 sm:mt-16 md:mt-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold text-gray-900 sm:text-3xl sm:tracking-tight font-display",
                                        children: "Supportdesk"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-lg text-gray-500",
                                            children: "Heb je een technische vraag over het platform? Ons team staat voor je klaar."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-9",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon, {
                                                            className: "h-6 w-6 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ml-3 text-base text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "tel:073 203 2572",
                                                                className: "text-gray-500 hover:text-gray-600",
                                                                children: "073 203 2572"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "mt-1",
                                                                children: "Ma-Vr van 09:00 tot 17:00"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6 flex",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvelopeIcon, {
                                                            className: "h-6 w-6 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-3 text-base text-gray-500",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:support@bijlesplein.nl",
                                                            className: "text-gray-500 hover:text-gray-600",
                                                            children: "support@bijlesplein.nl"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-12 sm:mt-16 md:mt-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {})
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 8391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ TextArea; },
/* harmony export */   "nv": function() { return /* binding */ TextField; }
/* harmony export */ });
/* unused harmony export SelectField */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);


const formClasses = "block w-full appearance-none rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm";
function Label(param) {
    let { id , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: id,
        className: "mb-3 block text-sm font-medium text-gray-700",
        children: children
    });
}
function TextField(param) {
    let { id , label , type ="text" , className ="" , register , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                id: id,
                type: type,
                ...register,
                ...props,
                className: formClasses
            })
        ]
    });
}
function TextArea(param) {
    let { id , label , className ="" , register , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                id: id,
                ...register,
                ...props,
                className: formClasses
            })
        ]
    });
}
function SelectField(param) {
    let { id , label , className ="" , ...props } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ _jsx(Label, {
                id: id,
                children: label
            }),
            /*#__PURE__*/ _jsx("select", {
                id: id,
                ...props,
                className: clsx(formClasses, "pr-8")
            })
        ]
    });
}


/***/ })

}]);